export const messageTypes = {
  SET_NEW_MESSAGE: 'SET_NEW_MESSAGE',
  SET_DEPARTMENTS: 'SET_DEPARTMENTS',
  SET_ACTIVE_DEPARTMENT: 'SET_ACTIVE_DEPARTMENT',
  SET_ACCEPTED_CHAT: 'SET_ACCEPTED_CHAT',
  SET_MESSAGE_STATUS: 'SET_MESSAGE_STATUS',
  SET_FORM_MESSAGE: 'SET_FORM_MESSAGE',
  SEND_MESSAGE: 'SEND_MESSAGE',
  SET_USER_INPUT: 'SET_USER_INPUT',
  SEND_FILE_MESSAGE: 'SEND_FILE_MESSAGE',
  UPLOAD_FILE: 'UPLOAD_FILE',
  SET_VOICE_RECORDING: 'SET_VOICE_RECORDING',
  SEND_FOMR_MESSAGE: 'SEND_FOMR_MESSAGE',
  SET_USER_FORM_STATUS: 'SET_USER_FORM_STATUS',
  TYPE_NEW_WORD: 'TYPE_NEW_WORD',
  SET_FETCH_MORE_MESSAGES: 'SET_FETCH_MORE_MESSAGES',
  FETCH_MORE_MESSAGES_START: 'FETCH_MORE_MESSAGES_START',
  SET_OLD_MESSAGES: 'SET_OLD_MESSAGES',
  SET_DISABLE_INPUT: 'SET_DISABLE_INPUT',
  SET_RECORDING_AUDIO: 'SET_RECORDING_AUDIO',
  GET_ACCEPTED_CHAT: 'GET_ACCEPTED_CHAT',
  SET_OFFLINE_MESSAGE: 'SET_OFFLINE_MESSAGE',
  UPDATE_ACCEPTED_CHAT_AVATAR: 'UPDATE_ACCEPTED_CHAT_AVATAR',
  SET_CONNECTION_ERROR: 'SET_CONNECTION_ERROR',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_AUDIO_STREAM: 'SET_AUDIO_STREAM',
  GET_USER_FROM_API: 'GET_USER_FROM_API',
  SET_SOCKET_CONNECTION_ERROR: 'SET_SOCKET_CONNECTION_ERROR',
  SET_DEFAULT_ONLINE_AGENT: 'SET_DEFAULT_ONLINE_AGENT',
  SET_DEFAULT_TEAM: 'SET_DEFAULT_TEAM',
  REMOVE_ACCEPTED_CHAT: 'REMOVE_ACCEPTED_CHAT',
  REMOVE_FORM_MESSAGE: 'REMOVE_FORM_MESSAGE',
  SET_REPLYING_MESSAGE: 'SET_REPLYING_MESSAGE',
  SET_EDITED_MESSAGE: 'SET_EDITED_MESSAGE',
  REMOVE_CONVERSATION_NOT_SEEN_START: 'REMOVE_CONVERSATION_NOT_SEEN_START',
  SET_MSG_STATUS: 'SET_MSG_STATUS',
  SET_MSG_ID: 'SET_MSG_ID',
  SET_SEEN_STATUS_FOR_ALL_MESSAGES: 'SET_SEEN_STATUS_FOR_ALL_MESSAGES',
  SET_MESSAGE_ID: 'SET_MESSAGE_ID',
  SET_SELECTED_QUESTION: 'SET_SELECTED_QUESTION',
  RECORD_ROADMAP_CHECKPOINT: 'RECORD_ROADMAP_CHECKPOINT',
  SEND_DYNAMIC_FORM_MESSAGE: 'SEND_DYNAMIC_FORM_MESSAGE',
  SET_FORMS: 'SET_FORMS',
  DISPATCH_FORM_AND_MESSAGE: 'DISPATCH_FORM_AND_MESSAGE',
  CHANGE_BOT_MSG_TO_TEXT: 'CHANGE_BOT_MSG_TO_TEXT',
  SET_FORM_STATUS: 'SET_FORM_STATUS',
  HIDE_CHAT_INPUT_FOR_TEAM: 'HIDE_CHAT_INPUT_FOR_TEAM',
  SET_SHOW_GREETING_INPUT: 'SET_SHOW_GREETING_INPUT',
  SET_NOT_SEEN_RECEIVED_MSGS: 'SET_NOT_SEEN_RECEIVED_MSGS',
  INCREMENT_NOT_SEEN_RECEIVED_MSGS: 'INCREMENT_NOT_SEEN_RECEIVED_MSGS',
  RESTART_FLOW_OPERATION: 'RESTART_FLOW_OPERATION',
  TALK_WITH_OPERATOR_INSTEAD_OF_BOT: 'TALK_WITH_OPERATOR_INSTEAD_OF_BOT',
  SET_UPLOAD_PROGRESS_DATA: 'SET_UPLOAD_PROGRESS_DATA',
  SET_CONFIRM_UPLOADED_DATA: 'SET_CONFIRM_UPLOADED_DATA',
  SET_USER_DID_CONFIRM_THE_UPLOADED_DATA: 'SET_USER_DID_CONFIRM_THE_UPLOADED_DATA',
  SET_UPLOAD_ERROR: 'SET_UPLOAD_ERROR',
  SET_REMOVE_MSG_BY_TMP_ID: 'SET_REMOVE_MSG_BY_TMP_ID',
  SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
  SET_FEEDBACK_BOX_VALUES: 'SET_FEEDBACK_BOX_VALUES',
  REMOVE_MESSAGE: 'REMOVE_MESSAGE',
  OPEN_WIDGET_AUTO_MSG_ACTION: 'OPEN_WIDGET_AUTO_MSG_ACTION',
  SET_SENT_CLOSE_BUTTON: 'SET_SENT_CLOSE_BUTTON',
  SEND_SENT_CLOSE_BUTTON_ACTION: 'SEND_SENT_CLOSE_BUTTON_ACTION',
}
